export { default } from './HideAddressApp';
